import { PortalThemeColors } from '@nx-frontend/shared/types';
import { ThemeCarbon } from './themes/carbon/theme';
import { ThemeTheDarkNight } from './themes/dark-night/theme';
import { ThemeLemonDrop } from './themes/lemon-drop/theme';
import { ThemeTheLightBlue } from './themes/light-blue/theme';
import { ThemeTheLightOrange } from './themes/light-orange/theme';
import { ThemeExperimental, ThemeExperimental2, ThemeLightPurple } from './themes/light-purple/theme';
import { ThemeMilkyBlue } from './themes/milky-blue/theme';
import { ThemeOxford } from './themes/oxford/theme';
import { ThemeQuiteGreen } from './themes/quite-green/theme';
import { ThemeSavvyRed } from './themes/savvy-red/theme';
import { ThemeShadesOfGreen } from './themes/shades-of-green/theme';
import { ThemeSketchyDigital } from './themes/sketchy-digital/theme';
import { ThemeSoftLight } from './themes/soft-light/theme';
import { ThemeTheSpaceGray } from './themes/space-gray/theme';
import { ThemeUltramarine } from './themes/ultramarine/theme';
import { ThemeWedding_1 } from './themes/wedding/theme';

export const portalThemeColors: PortalThemeColors[] = [
  ThemeLightPurple,
  ThemeTheSpaceGray,
  ThemeTheLightOrange,
  ThemeTheLightBlue,
  ThemeTheDarkNight,
  ThemeShadesOfGreen,
  ThemeWedding_1,
  ThemeSketchyDigital,
  ThemeLemonDrop,
  ThemeUltramarine,
  ThemeQuiteGreen,
  ThemeOxford,
  ThemeCarbon,
  ThemeMilkyBlue,
  ThemeSoftLight,
  ThemeSavvyRed,
  ThemeExperimental,
  ThemeExperimental2,
];
